export default {
    url: '/add',
    template: '<manage-permissions-roles-add role="vm.role"/>',
    controller (RoleResource) {
        this.role = new RoleResource({ privilegesJson: [] });
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/permissions/roles/add/index.js